var option_default = {
  "option": "ccntI",
  "user_choice": "lCQ3e",
  "check": "nNoNW",
  "image": "ZEup7",
  "input": "_1sV43",
  "title": "Ri-6E",
  "centered": "oqSG2",
  "with_result": "AqkxB",
  "list": "POt7C",
  "with_image": "P42Dm",
  "progress": "tXcDg",
  "progress_value": "gwv8h",
  "label": "_9sUi9",
  "cta": "fnDa0",
  "adornment_icon": "LgKzI",
  "remove": "J4RhE",
  "removeButton": "qlvAU",
  "removeButtonIcon": "dWJzj",
  "overlay": "-qw0c",
  "shown": "jBUhF",
  "dark": "_0FrIU",
  "spinner": "sAp3j",
  "spin": "HZvvp"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
